/*
 *  Product Thumbnails Carousel
 *    Scripts for the Collection Carousel section. Creates a slick slide for
 *    smaller devices.
 *
 *  Version:
 *    1.0.0 - 2020/03/19
 */

import { CarouselSection } from './CarouselSection';
import { register } from './../sections/ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

const CONTAINER_SELECTOR = '[data-products-carousel-container]';
const CAROUSEL_SELECTOR = '[data-products-carousel]';

export class ProductsCarousel extends CarouselSection {
  constructor(container) {
    super(container);
    this.carouselSelector = container.find(CAROUSEL_SELECTOR);

    this.slick = this.initCarousel(this.carouselSelector);
  }

  optionOverrides() {
    return {
      slidesToShow: 1,
      infinite: true,
      mobileFirst: true,
      arrows: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true
          }
        }
      ]
    }
  }
}

register(CONTAINER_SELECTOR, ProductsCarousel);